import apiClient from './client';

export type MemberDocType = 'card-simple' | 'card-complete';
export type FamilyDocType = 'card-simple' | 'card-complete';

export async function getMemberCard(memberId: string, type: MemberDocType): Promise<Blob> {
  const response = await apiClient.get(`/documents/member/${memberId}/${type}`, {
    responseType: 'blob',
  });
  return response.data as Blob;
}

export async function getFamilyCard(familyId: string, type: FamilyDocType): Promise<Blob> {
  const response = await apiClient.get(`/documents/family/${familyId}/${type}`, {
    responseType: 'blob',
  });
  return response.data as Blob;
}

export async function generateTransferLetter(
  memberId: string,
  data: {
    destination_church: string;
    destination_city?: string;
    reason?: string;
    decision_date?: string;
    special_mentions?: string;
    membership_period?: string;
  },
): Promise<{ data: { id: string; file_path: string } }> {
  const response = await apiClient.post(`/documents/transfer/${memberId}`, data);
  return response.data;
}

export interface GeneratedDocRecord {
  id: string;
  type: string;
  metadata: Record<string, string> | null;
  created_at: string;
}

export async function getMemberDocuments(memberId: string): Promise<GeneratedDocRecord[]> {
  const response = await apiClient.get(`/documents/member/${memberId}/history`);
  return (response.data as { data: GeneratedDocRecord[] }).data;
}

export async function downloadDocument(documentId: string): Promise<Blob> {
  const response = await apiClient.get(`/documents/${documentId}/download`, {
    responseType: 'blob',
  });
  return response.data as Blob;
}
